import { FormControlLabel, SxProps, Theme } from '@mui/material';
import { forwardRef } from 'react';
import { CoreCheckbox, CoreCheckboxProps } from '../core-checkbox';
import { clsx } from '../../../utils';
import { labelStyle } from './core-labeled-checkbox.styles';

export interface CoreLabeledCheckboxProps extends CoreCheckboxProps {
	label?: string | null | React.ReactNode;
	labelSx?: SxProps<Theme>;
	error?: boolean;
}

export const CoreLabeledCheckbox = forwardRef(
	({ label, labelSx, error, ...props }: Omit<CoreLabeledCheckboxProps, 'ref'>, ref) => (
		<FormControlLabel
			sx={clsx(labelStyle, labelSx)}
			className={error ? 'Mui-error' : ''}
			label={label}
			required={props.required}
			disabled={props.disabled}
			control={<CoreCheckbox ref={ref} {...props} />}
		/>
	)
);

CoreLabeledCheckbox.displayName = 'CoreLabeledCheckbox';
